import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Lock, User } from 'lucide-react';
import './Admin.css';

function AdminLogin({ setIsAdmin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username.trim() === 'admin' && password === 'admin123') {
      setIsAdmin(true);
      setError('');
      navigate('/admin/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-box">
        <div className="admin-login-icon">
          <ShieldCheck size={40} />
        </div>
        <h1>Bayt Al-Khayr Admin</h1>
        <p>Sign in to access the management dashboard</p>

        <form onSubmit={handleLogin}>
          <div className="admin-form-group">
            <label><User size={14} /> Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter admin username"
              required
            />
          </div>
          <div className="admin-form-group">
            <label><Lock size={14} /> Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
            />
          </div>

          {error && <p className="admin-login-error">{error}</p>}

          <button type="submit" className="admin-login-btn">
            Sign In to Dashboard
          </button>
        </form>

        <p className="admin-demo-hint">Demo credentials: admin / admin123</p>
      </div>
    </div>
  );
}

export default AdminLogin;
